module.exports = __webpack_public_path__ + "img/Seccion5-Movil.701d0d79.png";